import { render, staticRenderFns } from "./AllAwards.vue?vue&type=template&id=3bf7e06e&"
import script from "./AllAwards.vue?vue&type=script&lang=js&"
export * from "./AllAwards.vue?vue&type=script&lang=js&"
import style0 from "./AllAwards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports